"use client"

import Script from "next/script"
import { usePathname } from "next/navigation"
import { useEffect } from "react"

const CRISP_WEBSITE_ID = process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID

export default function CrispChat() {
	const pathname = usePathname()
	const isManagerRoute = pathname?.startsWith("/manager")
	const isProd = process.env.NODE_ENV === "production"
	const canLoadCrisp = isProd && Boolean(CRISP_WEBSITE_ID)

	useEffect(() => {
		if (!canLoadCrisp) return
		if (!window.$crisp) return

		// Keep manager pages clean: hide widget when entering /manager, show elsewhere.
		if (isManagerRoute) {
			window.$crisp.push(["do", "chat:hide"])
		} else {
			window.$crisp.push(["do", "chat:show"])
		}
	}, [canLoadCrisp, isManagerRoute])

	if (!canLoadCrisp || isManagerRoute) return null

	return (
		<>
			<Script id="crisp-config" strategy="afterInteractive">
				{`
					window.$crisp = window.$crisp || [];
					window.CRISP_WEBSITE_ID = "${CRISP_WEBSITE_ID}";
				`}
			</Script>
			<Script
				id="crisp-sdk"
				src="https://client.crisp.chat/l.js"
				strategy="afterInteractive"
			/>
		</>
	)
}
